<ion-button [expand]="styles!.expand" [fill]="styles!.fill" [style.--background]="styles!.backgroundColor"
    [style.fontSize]="styles!.fontSize"
    [disabled]="dots && (loaderService.loading$ | async)" (click)="action.emit()">
    @if (dots && (loaderService.loading$ | async) && !(loaderService.overlay$ | async)) {
    <ion-spinner name="dots" [style.color]="styles!.color + '!important'"></ion-spinner>
    }

    @if (!dots || (!(loaderService.loading$ | async) && !(loaderService.overlay$ | async))) {
    <ion-label [style.color]="styles!.color" [style.fontSize]="styles!.fontSize">{{text}}</ion-label>
    }
</ion-button>
